// LoginPhone.js
import React, { useState } from 'react'
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage'
import Button from '../../components/Button/Button'
import { useNavigate } from 'react-router-dom'
import PhoneInput from '../../components/PhoneInput/PhoneInput'
import { useLanguage } from '../../LanguageProvider'
import './LoginPhone.css'
import { loginDocuments } from '../../store/legalDocuments';
import Checkbox from '../../components/Checkbox/Checkbox'

export default function LoginPhone() {
    const { getTranslation } = useLanguage();
    const navigate = useNavigate()
    const [method, setMethod] = useState('phone')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [isKvkkModalOpen, setIsKvkkModalOpen] = useState(false)
    const [isKvkkChecked, setIsKvkkChecked] = useState(false)
    const [activeKvkkTitle, setActiveKvkkTitle] = useState('')
    const [activeKvkkContent, setActiveKvkkContent] = useState('')
    
    const handlePhoneChange = (e) => {
        const input = e.target.value
        if (input.length <= 10) setPhoneNumber(input)
    }

    const handleEmailChange = (e) => setEmail(e.target.value)

    const isValid = () => {
        if (!isKvkkChecked) return false
        return method === 'phone' ? phoneNumber.length === 10 : email.trim() !== ''
    }

    const handleOpenKvkkModal = (title, content) => {
        setActiveKvkkTitle(title)
        setActiveKvkkContent(content)
        setIsKvkkModalOpen(true)
    }

    const handleKvkkCheckboxChange = () => {
        if (isKvkkChecked) {
            setIsKvkkChecked(false)
            return
        }

        setIsKvkkChecked(true)
        handleOpenKvkkModal(
            getTranslation("loginKvkkLinkLabel") || loginDocuments.kvkk.title,
            loginDocuments.kvkk.content
        )
    }

    const handleCloseKvkkModal = () => {
        setIsKvkkModalOpen(false)
    }

    const handleSubmit = () => {
        localStorage.setItem('loginMethod', method)
        if (method === 'phone') {
            localStorage.setItem('loginPhone', phoneNumber)
            localStorage.removeItem('loginEmail')
        } else {
            localStorage.setItem('loginEmail', email)
            localStorage.removeItem('loginPhone')
        }
        navigate('/login-otp', {
            state: { method, phoneNumber, email }
        })
    }

    return (
        <div>
            <WelcomeMessage
                message={method === 'phone'
                    ? getTranslation("enterPhoneForLogin")
                    : getTranslation("enterEmailForLogin")}
            />

            <div style={{ marginTop: 20 }}>
                <label>
                    <input
                        type="radio"
                        name="loginMethod"
                        value="phone"
                        checked={method === 'phone'}
                        onChange={() => setMethod('phone')}
                    />{' '}
                    {getTranslation("phone")}
                </label>
                <label style={{ marginLeft: 16 }}>
                    <input
                        type="radio"
                        name="loginMethod"
                        value="email"
                        checked={method === 'email'}
                        onChange={() => setMethod('email')}
                    />{' '}
                    {getTranslation("email")}
                </label>
            </div>

            <div style={{ marginTop: 25 }}>
                {method === 'phone' ? (
                    <PhoneInput
                        value={phoneNumber}
                        handlePhoneChange={handlePhoneChange}
                        label={getTranslation("phoneNumber")+" *"}
                        placeholder="5XXXXXXXXX"
                    />
                ) : (
                    <div style={{ flexDirection: 'column', display: 'flex', gap: '5px' }}>
                        <label style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(52, 64, 84, 1)', marginBottom: '6px' }} htmlFor="emailInput">{getTranslation("emailAddressLabel")}</label>
                        <input
                            id="emailInput"
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder={getTranslation("emailPlaceholder")}
                            style={{
                                border: "1px solid rgba(209, 213, 219, 1)",
                                height: "48px",
                                borderRadius: '5px',
                                backgroundColor: 'rgba(249, 250, 251, 1)',
                                paddingInline: '10px'
                            }}
                        />
                    </div>
                )}
            </div>

            <div className="login-kvkk-links">
                <div className="login-kvkk-link-row">
                    <Checkbox
                        checked={isKvkkChecked}
                        onChange={handleKvkkCheckboxChange}
                    />
                    <button
                        type="button"
                        className="login-kvkk-link-button"
                        onClick={() =>
                            handleOpenKvkkModal(
                                getTranslation("loginKvkkLinkLabel") || loginDocuments.kvkk.title,
                                loginDocuments.kvkk.content
                            )
                        }
                    >
                        {getTranslation("loginKvkkLinkLabel") || loginDocuments.kvkk.title} <span>{getTranslation("clickHereSuffix") || "için tıklayınız."}</span>
                    </button>
                </div>
            </div>

            <Button
                label={getTranslation("getCode")}
                variant="primary"
                style={{ width: '100%', marginTop: 32, height: 44 }}
                disabled={!isValid()}
                onClick={handleSubmit}
            />

            {isKvkkModalOpen && (
                <div className="login-kvkk-modal-overlay">
                    <div className="login-kvkk-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="login-kvkk-modal-body">
                            <h2 className="login-kvkk-modal-title">{activeKvkkTitle}</h2>
                            <div dangerouslySetInnerHTML={{ __html: activeKvkkContent }} />
                        </div>
                        <button
                            type="button"
                            className="login-kvkk-modal-close-button"
                            onClick={handleCloseKvkkModal}
                        >
                            {getTranslation("read")}
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
